import React from "react";

const defaultProductData = [
  {
    product: "",
    Description: "",
    action: "",
  },
];

const ProductRiskTable = ({ productrows, setProductRows }) => {
  const handleChange = (index, field, value) => {
    const updated = [...productrows];
    updated[index][field] = value;
    setProductRows(updated);
  };

  const addRow = () => {
    setProductRows([...productrows, { product: "", risk: "", action: "" }]);
  };

  const removeRow = (index) => {
    const updated = [...productrows];
    updated.splice(index, 1);
    setProductRows(updated);
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          overflowX: "auto",
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
              <th style={headerStyle}>Name of the Product / Service</th>
              <th style={headerStyle}>Description of Risk / Concern</th>
              <th style={headerStyle}>Action Taken</th>
            </tr>
          </thead>
          <tbody>
            {productrows.map((row, idx) => (
              <tr key={idx}>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Product / Service"
                    value={row.product}
                    onChange={(e) =>
                      handleChange(idx, "product", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.risk}
                    onChange={(e) => handleChange(idx, "risk", e.target.value)}
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.action}
                    onChange={(e) =>
                      handleChange(idx, "action", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        {productrows.length > 1 && (
          <button onClick={removeRow} style={removeButtonStyle}>
            - Remove
          </button>
        )}
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const cellStyle = {
  padding: "16px", // increased padding for vertical space
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const inputStyle = {
  width: "100%",
  padding: "10px 6px", // more vertical padding
  minHeight: "48px", // ensures taller input boxes
  lineHeight: "1.4",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default ProductRiskTable;
